import { render, staticRenderFns } from "./indexScroll.vue?vue&type=template&id=f7db9050&scoped=true&"
import script from "./indexScroll.vue?vue&type=script&lang=js&"
export * from "./indexScroll.vue?vue&type=script&lang=js&"
import style0 from "./indexScroll.vue?vue&type=style&index=0&id=f7db9050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7db9050",
  null
  
)

export default component.exports